import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./SignUpStep.module.scss";

const OtpInput = ({ value, onChange, error }) => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const otpArray = (value || "").split("").slice(0, 6);
  while (otpArray.length < 6) otpArray.push("");

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    if (!val && e.target.value) return; // ignore non-numeric

    if (isAr) {
      if (value.length < 6) {
        onChange(value + val);
        if (e.target.nextSibling) {
          e.target.nextSibling.focus();
        }
      }
    } else {
      let newOtp = [...otpArray];
      newOtp[index] = val;
      onChange(newOtp.join(""));
      if (val && e.target.nextSibling) {
        e.target.nextSibling.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (isAr) {
        if (value.length > 0) {
          onChange(value.slice(0, -1));
          if (e.target.previousSibling) {
            e.target.previousSibling.focus();
          }
        }
      } else {
        if (!otpArray[index] && e.target.previousSibling) {
          e.target.previousSibling.focus();
        }
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData
      .getData("text")
      .replace(/[^0-9]/g, "")
      .slice(0, 6);
    if (pastedData) {
      onChange(pastedData);
      const inputIndex = Math.min(pastedData.length, 5);
      const inputs = e.target.parentElement.querySelectorAll("input");
      if (inputs[inputIndex]) {
        inputs[inputIndex].focus();
      }
    }
  };

  return (
    <div className={styles.otpInputs} dir={isAr ? "rtl" : "ltr"}>
      {[0, 1, 2, 3, 4, 5].map((index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          className={`${styles.otpInput} ${error ? styles.error : ""}`}
          value={
            (isAr
              ? value.length > index
                ? value[value.length - 1 - index]
                : ""
              : otpArray[index]) || ""
          }
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

export default OtpInput;

